export * from '../application/use_cases/consent/MarketingConsent';
export * from './acquisitions';
export * from './prices';

/* Timeout in milliseconds */
export const DEFAULT_TIMEOUT = 30000;

export interface MetaItem {
  type: 'query_parameter' | 'ab_test';
  name: string;
  value: string;
}
